import { Auth0Config, LoginGlobalError, LoginFieldError, JWT, OidcContext } from '../../types';
import { BaseRedirectState, BasePageState } from './pageStateTypes';
import { useAppSelector } from '../../stores/redux.store';
import { State as CobrandingState } from '../../reducers/cobranding-reducer';

interface LoginPageAppConfig {
  googleAuthClientId: string;
  auth0Config: Auth0Config;
  recaptchaEnable: boolean;
  recaptchaEnterpriseCheckboxKeySite: string;
}

export type LoginStateResult = BaseRedirectState | LoginPageState;

export interface LoginPageState extends BasePageState {
  appConfig: LoginPageAppConfig;
  hashedCsrfToken: string;
  cobranding: CobrandingState;
  csrfToken: string;
  login?: {
    error?: LoginGlobalError;
    fieldErrors?: LoginFieldError;
    recoveryToken?: JWT;
  };
  oidcContext?: OidcContext;
}

export const useLoginState = () => {
  const appConfig = useAppSelector(state => state.appConfig);
  const csrfToken = useAppSelector(state => state.csrfToken);
  const cobranding = useAppSelector(state => state.cobranding);
  const hashedCsrfToken = useAppSelector(state => state.hashedCsrfToken);
  const login = useAppSelector(state => state.login);
  const oidcContext = useAppSelector(state => state.microbranding.oidcContext);

  const state: LoginPageState = {
    type: 'page-state',
    appConfig,
    csrfToken,
    cobranding,
    hashedCsrfToken,
    login,
    oidcContext,
  };

  return {
    state,
    isLoading: false,
    isError: false,
    isSuccess: true,
    error: undefined,
  };
};
